import { useTranslation } from 'react-i18next';
import React from 'react';
import { CommonFields } from '../common/CommonFields';
import {
  IFormWrapperProps,
  UpdateVendorFormFieldsMap,
} from '../../interfaces';
import { AdditionalFields } from '../../components/AdditionalFields';
import { DomesticAddressFields } from '../mailCheck/DomesticAddressFields';
import { DomesticWireTransferFields } from './DomesticWireTransferFields';
import { InternationalAddressFields } from '../internationalWireTransfer/InternationalAddressFields';
import { InternationalBaseFields } from '../internationalWireTransfer/InternationalBaseFields';
import Heading from '../../../../generic-components/Heading';
import { AchOutTransferFields } from '../achOutTransfer/AchOutTransferFields';

export const DomesticWireTransferFormWrapper = ({ vendorData, moveType, formMethods, formType, isVendorUpdateMandatory, isUpdateNameRequired }: IFormWrapperProps) => {
  const { t } = useTranslation();
  const reactiveCountry = formMethods.watch(UpdateVendorFormFieldsMap.INTER_COUNTRY);

  const additionalFieldsList = [
    {
      title: t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.ACH_TRANSFER'),
      body: <AchOutTransferFields formMethods={formMethods} />,
    },
    {
      title: t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.INTERNATIONAL_WIRE'),
      body: (
        <div className='flex flex-col'>
          <InternationalBaseFields vendorData={vendorData} moveType={moveType} dynamicCountry={reactiveCountry} formMethods={formMethods} />
          <InternationalAddressFields dynamicCountry={reactiveCountry} formMethods={formMethods} />
        </div>
      ),
    },
  ];

  const shouldShowCommonFields = () => {
    if (isUpdateNameRequired) {
      return true;
    }
    return !isVendorUpdateMandatory;
  };

  const shouldShowMainFields = () => {
    if (isVendorUpdateMandatory) {
      return true;
    }
    return !isUpdateNameRequired;
  };

  return (
    <div className='flex flex-col'>
      {shouldShowCommonFields() && <CommonFields isUpdateNameRequired={isUpdateNameRequired} formMethods={formMethods} formType={formType} />}
      {shouldShowMainFields() && <DomesticWireTransferFields formMethods={formMethods} />}
      {shouldShowMainFields() && <DomesticAddressFields formMethods={formMethods} />}
      {!isVendorUpdateMandatory && !isUpdateNameRequired && <Heading
        id='additionalRecipient'
        title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.ADDITIONAL_DETAILS')}
        className='font-metricRMedium text-[16px] text-bw08 mt-[32px] mb-[24px]'
      />}
      {!isVendorUpdateMandatory && !isUpdateNameRequired && <AdditionalFields additionalFieldsList={additionalFieldsList} /> }
    </div>
  );
};
